import { ProductScreenshot } from 'components/ProductScreenshot';
import { ProductVideo } from 'components/ProductVideo';
import popoverLight from "../../../../contents/images/docs/notebooks/popover-light-mode.mp4";
import popoverDark from "../../../../contents/images/docs/notebooks/popover-dark-mode.mp4";
import switchLight from "../../../../contents/images/docs/notebooks/switch-light-mode.mp4";
import switchDark from "../../../../contents/images/docs/notebooks/switch-dark-mode.mp4";
import slashLight from "../../../../contents/images/docs/notebooks/slash-light-mode.mp4";
import slashDark from "../../../../contents/images/docs/notebooks/slash-dark-mode.mp4";
import plusLight from "../../../../contents/images/docs/notebooks/plus-light-mode.mp4";
import plusDark from "../../../../contents/images/docs/notebooks/plus-dark-mode.mp4";
import dragLight from "../../../../contents/images/docs/notebooks/drag-light-mode.mp4";
import dragDark from "../../../../contents/images/docs/notebooks/drag-dark-mode.mp4";
import insightsLight from "../../../../contents/images/docs/notebooks/insights-light-mode.mp4";
import insightsDark from "../../../../contents/images/docs/notebooks/insights-dark-mode.mp4";
import eventsLight from "../../../../contents/images/docs/notebooks/events-light-mode.png";
import eventsDark from "../../../../contents/images/docs/notebooks/events-dark-mode.png";
import playlistLight from "../../../../contents/images/docs/notebooks/playlist-light-mode.mp4";
import playlistDark from "../../../../contents/images/docs/notebooks/playlist-dark-mode.mp4";
import replayLight from "../../../../contents/images/docs/notebooks/replay-light-mode.mp4";
import replayDark from "../../../../contents/images/docs/notebooks/replay-dark-mode.mp4";
import flagLight from "../../../../contents/images/docs/notebooks/flag-light-mode.png";
import flagDark from "../../../../contents/images/docs/notebooks/flag-dark-mode.png";
import surveyLight from "../../../../contents/images/docs/notebooks/survey-light-mode.png";
import surveyDark from "../../../../contents/images/docs/notebooks/survey-dark-mode.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  ProductVideo,
  popoverLight,
  popoverDark,
  switchLight,
  switchDark,
  slashLight,
  slashDark,
  plusLight,
  plusDark,
  dragLight,
  dragDark,
  insightsLight,
  insightsDark,
  eventsLight,
  eventsDark,
  playlistLight,
  playlistDark,
  replayLight,
  replayDark,
  flagLight,
  flagDark,
  surveyLight,
  surveyDark,
  React
};